import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import DEFINE, { UPLOAD_DIRECTORY, VALIDATE_ENUM, DETAIL_ACTIONS, FEATURE_FLAGS, PATHS, DATE_TIME_FORMAT, INSTALLMENT as INSTALLMENT_ENUM } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import { message, Icon, Input as AntInput, Switch } from 'antd';
import AntSelect, { AntOption } from '../../../common/component/AntSelect'
import Input from '../../../common/component/Input';
import Wrapper from './../../../common/component/Wrapper';
import Button from './../../../common/component/Button';
import RichTextEditor, { ClassicEditor } from '../../../common/component/RichTextEditor';
import TextArea from '../../../common/component/TextArea';
import UploadImage from '../../../common/component/UploadImage';
import { omit, cloneDeep, merge, every, toArray, get, find } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import Amenity from '../../../../../models/Amenity';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';
// import './AmenityDetail.less';

const defaultValue = {
    action: DETAIL_ACTIONS.CREATE,
    amenity: new Amenity(),
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
    isUpload: false,
    isUploadMultiple: false,
    thumbImage: {},
};
class AmenityDetail extends Component {

    state = cloneDeep(defaultValue);

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE, amenity: cloneDeep(defaultValue.amenity) });
            this.props.getAmenityDetail(match.params.id);
        }
    }

    validation = (field, reload) => {
        const { t, dataUpdate } = this.props;
        let amenity = this.state.amenity;
        let result = {};
        if (!reload) {
            let validate = {
                required: {
                    code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.amenity.code`)),
                }
            };
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
            }
            let valueValidate = {};
            result = Func.multipleValidate(amenity, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.amenityState.isSubmit,
            isGetItem: nextProps.amenityState.isGetItem,
            isUpload: nextProps.file.isFetching,
            isUploadMultiple: nextProps.file.isFetchingMultiple,
            isFetchingUpdate: nextProps.amenityState.isFetchingUpdate
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.amenityState.detail.amenity !== prevProps.amenityState.detail.amenity) {
            let { thumbImageName, thumbImageView } = this.props.amenityState.detail.amenity;
            let amenity = this.props.amenityState.detail.amenity;
            this.setState({
                amenity: merge(amenity, {
                    thumbImage: (thumbImageView && thumbImageView.filename) || thumbImageName,
                    thumbImageView: thumbImageView
                }),
                thumbImage: thumbImageView || undefined,
            })
        }
        if (this.props.file !== prevProps.file) {
            
            if (this.props.file.file) {
                let oldThumbImage = this.state.thumbImage;
                let thumbImageName = this.state.amenity.url ? this.state.amenity.url : "";
                if (this.props.file.file.type === 0) {
                    oldThumbImage = this.props.file.file.data;
                    thumbImageName = this.props.file.file.data.fileUrl;
                }
                this.setState({
                    file: this.props.file.file.type === 0 ? this.props.file.file : undefined,
                    amenity: merge(this.state.amenity, {
                        url: thumbImageName,
                    }),
                    thumbImage: oldThumbImage || undefined,
                });
            }
        }
    }

    onChange = (e, tag) => {
        const amenity = this.state.amenity;
        if (tag) {
            amenity[tag] = e;
            this.setState({ amenity });
            this.validation(tag, true)
        } else {
            let params = Func.getValueForm(e);
            amenity[params.name] = typeof params.value === 'string' ? params.value.trimLeft() : params.value;
            this.setState({ amenity });
            this.validation(params.name, true)
        }
    };

    onChangeField = (field, value) => {
        const amenity = this.state.amenity;
        amenity[field] = value;
        this.setState({ amenity });
    }

    onChangeUrlSlug = (e) => {
        const value = Func.formatUrlSlug(e.target.value);
        return this.onChange(value, 'urlSlug');
    }

    onSubmit = (e) => {
        e.preventDefault();
        let { action, amenity } = this.state
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            let newData = this.state.amenity;

            if (action === DETAIL_ACTIONS.CREATE || action === DETAIL_ACTIONS.TRANSLATE) {
                this.saveAmenity(newData, this.props.createAmenityDetail);
            } else if (this.state.action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE) {
                let newData = this.state.amenity;
                if (typeof newData.url !== 'string') {
                    newData.url = undefined;
                }
                
                this.saveAmenity({ amenity: merge(newData, { id: this.state.amenity.id }), props: this.props }, this.props.updateAmenityDetail);
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };
    
    saveAmenity = (params, updateFunc) => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onSaveTranslate(params.data)
        } else {
            updateFunc(params)
        }
    }

    onShowTranslate = (language) => {
        const { amenity } = this.state;
        amenity.setTranslate(language.code);
        amenity.setData();
        this.setState({ amenity, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const amenity = cloneDeep(this.state.amenity);
        const action = DETAIL_ACTIONS[amenity.id ? 'UPDATE' : 'CREATE'];
        amenity.setTranslate(undefined, true);
        amenity.setData();
        this.setState({ amenity, action });
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.AMENITY.LIST.path);
        }
    }

    onSaveTranslate = (amenity) => {
        amenity = amenity || this.state.amenity;
        const translateFunction = amenity.translate.id ? this.props.updateAmenityTranslate : this.props.createAmenityTranslate;
        translateFunction(amenity, amenity.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { amenity } = this.state;
        amenity.setTranslate(language.code);
        this.props.deleteAmenityTranslate(amenity, { id: amenity.id });
    }

    uploadFile = (file) => {
        let amenity = this.state.amenity;
        amenity.url = undefined;
        this.setState({
            isUpload: true,
            amenity
        });
        this.props.onUploadFile({ file: file.target.files[0], directory: UPLOAD_DIRECTORY.AMENITY, isFile: 1 });
    };

    render() {
        const { t } = this.props;
        const { amenity, validation, isSubmit, isGetItem, action, isUpload, file, checkData, isUploadMultiple } = this.state;
        
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="vin-wonder-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'amenities'}
                            titleHeader={
                                action === DETAIL_ACTIONS.CREATE ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.amenity.title')}`))
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.amenity.title')}`))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={amenity.translations}
                                    current={amenity.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange(language.code, 'languageCode')}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            isGetItem={isGetItem}
                            activeComponent={true}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            submitButtonRight={true}
                        >
                            <HMS.FormWrapperItem>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={amenity.code}
                                        validation={validation.code}
                                        labelTitle={t(`item.amenity.code`)}
                                    >
                                        <Input type="text"
                                            autoComplete="off"
                                            disabled={action === DETAIL_ACTIONS.TRANSLATE}
                                            className="form-control" name="code" onChange={this.onChange}
                                            value={amenity.code ? amenity.code : ""} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        labelTitle={t(`item.vinWonder.name`)}
                                    >
                                        <Input type="text"
                                            autoComplete="off"
                                            className="form-control" name="name" onChange={this.onChange}
                                            value={amenity.name ? amenity.name : ""} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        labelTitle={t(`item.vinWonder.description`)}
                                    >
                                        <TextArea
                                            className="form-control" name="description" onChange={this.onChange}
                                            value={Func.checkUndefine(amenity.description)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent>
                                        <HMS.CheckboxComponent
                                            disabled={action === DETAIL_ACTIONS.TRANSLATE}
                                            name='isActive'
                                            className={`mr-4`}
                                            onChange={this.onChange}
                                            checked={amenity.isActive}>{t(`item.amenity.isActive`)}
                                        </HMS.CheckboxComponent>
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-3`}>
                                    <HMS.FormWrapperInputComponent
                                        // isRequired={true}
                                        // isValidation={true}
                                        // dataValidation={amenity.thumbImage}
                                        // validation={validation.thumbImage}
                                        labelTitle={t(`item.amenity.thumbImage`)}
                                    >
                                        <UploadImage
                                            disabledUpload={action === DETAIL_ACTIONS.TRANSLATE}
                                            multiple={false}
                                            loading={isUpload}
                                            thumbnailSize="100%"
                                            buttonSize={120}
                                            thumbnailStyle={{ maxHeight: 250 }}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFile}
                                            onRemoveThumbnail={this.removeThumbImage}
                                            thumbnails={this.state.amenity.url ? [this.convertUrlImage(this.state.amenity.url)] : undefined} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                {(action === DETAIL_ACTIONS.UPDATE) && (
                                    <AutoTranslate
                                        className="wrapper-full amenity"
                                        languageCode={amenity?.languageCode || 'vi-VN'}
                                        onChange={this.onChangeField}
                                        targetLanguage={amenity?.targetLanguage}
                                    />
                                )}
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }

    convertUrlImage(url) {
        return url.includes('https://') ? url : `https://${url}`
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    removeThumbImage = () => {
        this.setState({
            amenity: merge(this.state.amenity, {
                url: ""
            }),
            thumbImage: {},
        })
    }
}

export default withTranslation()(AmenityDetail);
